import '../../../../../stylesheets/nav/profile-popover.css'
import formatToLongDate from '../../../../../utilities/formatDate.js'
import { visaLogo, mastercardLogo, amexLogo, discoverLogo } from '../drawings.js'



const SubscriptionPayment = ( { subscription, paymentMethod } ) => {

    const cardLogoLegend = {
        visa:       visaLogo,
        amex:       amexLogo,
        mastercard: mastercardLogo,
        discover:   discoverLogo,
    }

    const walletLogoLegend = {
        apple_pay:  '/assets/apple-pay-logo.png',
        google_pay: '/assets/google-pay-logo.png',
    }


    return (

            <div className="subscription-details-content-container">

                {/* Main Col 1 of 3: Outer Only (since no inner but we are splitting inner into seperate container in this component if we every put content in this main column of this section - Left Margin PlaceHolder */}
                <div className="main-column-one"></div>

                {/* Main Col 2 of 3: Outer Only in this component, since we are following the architecture at the parent grid, where we are splitting inner into seperate container throughout this component - position of this column related to parent grid + margin and padding at this column container */}
                <div className="main-column-two details">

                    {/* Main Col 2 of 3: Seperate content wrapper for inner only */}
                    <div className="main-column-two-content-inner">

                        {/* Main Col 2's grid: Col 1 of 2 - span 3 rows via parent grid tracks */}
                        <div className="main-column-two-content-left-column">
                            { paymentMethod.paymentStatus && ( <div className="main-col-two-graphics label"> Payment Method </div> ) }
                            { paymentMethod.paymentStatus && ( <div style={{ display: "flex", alignItems: "center", gap: "8px"}}>
                                <span className="main-col-two-graphics"> {`•••• ${paymentMethod.ccLast4}`    }           </span>
                                <span className="main-col-two-graphics"> { cardLogoLegend[paymentMethod.ccBrand] }           </span>
                            </div> ) }
                            { subscription.paymentStatus && ( <div className="main-col-two-graphics renewal"> {`Your subscription will auto renew ${formatToLongDate(subscription.renewalDate)} `} </div> ) }
                        </div>

                        {/* Main Col 2's grid: Col 2 of 2 - span three rows via parent grid tracks */}
                        <div className="main-column-two-content-right-column">
                            { paymentMethod.paymentStatus && (<div className="main-col-two-graphics">                                           </div> ) }
                            { paymentMethod.wallet        && (<img src={walletLogoLegend[paymentMethod.wallet]} className="wallet-logo"             /> ) }
                            { paymentMethod.paymentStatus && (<div className="main-col-two-graphics">                                           </div> ) }
                        </div>

                    </div>

                </div>

                {/* Main Col 1 of 3: Outer Only (since no inner but we are splitting inner into seperate container in this component if we every put content in this main column of this section - Right Margin PlaceHolder */}
                <div className="main-column-three"></div>

            </div>

    )
}

export default SubscriptionPayment;
